import React from "react";
import ReactCountryFlag from "react-country-flag";
import { Mail, MapPin, Globe } from "lucide-react";

export default function GlobalContact() {
  // Country codes (ISO 3166-1 alpha-2)
  const countries = [
    { name: "USA", code: "US" },
    { name: "UK", code: "GB" },
    { name: "UAE", code: "AE" },
    { name: "Canada", code: "CA" },
    { name: "Germany", code: "DE" },
    { name: "Australia", code: "AU" },
    { name: "Singapore", code: "SG" },
    { name: "Japan", code: "JP" },
    { name: "France", code: "FR" },
    { name: "India", code: "IN" },
  ];

  return (
    <section className="relative py-16 px-6 lg:px-16 overflow-hidden bg-[#fbfbfb] dark:bg-[#050505] transition-colors duration-300">
      {/* Background Glows - Adjusted opacity for both modes */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-blue-500/5 blur-[140px] rounded-full pointer-events-none" />

      {/* Grid Pattern - Subtler for both modes */}
      <div className="absolute inset-0 opacity-[0.03] dark:opacity-[0.05] bg-[linear-gradient(rgba(0,0,0,1)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,1)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,1)_1px,transparent_1px)] bg-[size:60px_60px]" />

      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        {/* LEFT: Country Grid with ReactCountryFlag */}
        <div className="bg-white dark:bg-[#000000] p-8 rounded-3xl border border-gray-200 dark:border-gray-800">
          <h3 className="text-xl font-bold mb-6 flex items-center gap-2 text-gray-900 dark:text-white">
            <Globe className="text-orange-500" /> Serving Clients Globally
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {countries.map((c, i) => (
              <div
                key={i}
                className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-[#161616] rounded-xl border border-gray-100 dark:border-gray-800"
              >
                <ReactCountryFlag
                  countryCode={c.code}
                  svg
                  style={{ width: "1.5em", height: "1.5em" }}
                  title={c.name}
                />
                <span className="font-semibold text-gray-700 text-xs dark:text-gray-300">
                  {c.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT: Contact Info */}
        <div className="space-y-8">
          <div>
            <h4 className="text-orange-500 font-bold tracking-widest uppercase text-sm mb-3">
              Get Started
            </h4>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 dark:text-white mb-6">
              Connect For Your
              <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
                {" "}
                Project
              </span>
            </h2>
            <p className="text-gray-600 dark:text-gray-400 text-lg">
              We provide expert IT and Digital solutions for businesses
              worldwide. Reach out to us for a consultation.
            </p>
          </div>

          <div className="space-y-6">
            <a
              href="mailto:abroad@webxsecure.in"
              className="flex items-center gap-4 group"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-2xl flex items-center justify-center text-primary">
                <Mail size={24} />
              </div>
              <div>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Email Address
                </p>
                <p className="font-bold text-lg text-gray-900 dark:text-white group-hover:text-orange-500 transition-colors">
                  abroad@webxsecure.in
                </p>
              </div>
            </a>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-2xl flex items-center justify-center text-primary">
                <MapPin size={24} />
              </div>
              <div>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Global Operations
                </p>
                <p className="font-bold text-lg text-gray-900 dark:text-white">
                  Available 24/7 for Global Timezones
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
